/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2, breakpoints } from '@coursera/cds-core';

import ContextualHelpDialog from 'bundles/program-loggedin-shared/components/ContextualHelpDialog';

import _t from 'i18n!nls/degree-home';

const styles = {
  duplicateCourseTitle: () => css`
    ${breakpoints.down('xs')} {
      margin-bottom: var(--cds-spacing-300);
      padding: 0 var(--cds-spacing-300);
    }
  `,
  content: () => css`
    margin-bottom: var(--cds-spacing-200);
  `,
};

const DuplicateCoursesDialog: React.FC = () => {
  return (
    <div css={styles.duplicateCourseTitle}>
      <ContextualHelpDialog
        label={
          <Typography2 variant="bodyPrimary" component="span">
            {_t('There are duplicated courses in this program')}
          </Typography2>
        }
        dialogHeading={_t('Disclaimers')}
        ariaLabel={_t('View disclaimer')}
        data-testid="info-icon"
      >
        <Typography2 component="p" css={styles.content}>
          {_t(
            /* eslint-disable-next-line no-restricted-syntax */
            'When a course is offered in multiple segments and you complete it, your progress will count towards the completion of all segments where the course is available. However, it will only count once towards your graduation.'
          )}
        </Typography2>
      </ContextualHelpDialog>
    </div>
  );
};

export default DuplicateCoursesDialog;
